<template>
  <div class="fe-spacing-vertical">
    <div class="fe-grid fe-grid-cols-12 fe-gap-base">
      <div class="fe-col-span-3">
        <div class="fe-mb-xl">
          <RatingSummary />
        </div>
        <div>
          <RatingCta />
        </div>
      </div>

      <div class="fe-col-start-5 fe-col-span-8">
        <MyReviewList class="fe-mb-m" />
        <GalleryList class="fe-mb-m" />

        <div>
          <ReviewList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RatingSummary from "@/components/ReviewAndRating/RatingSummary/RatingSummary.vue"
  import RatingCta from "@/components/ReviewAndRating/RatingCta/RatingCta.vue"
  import GalleryList from "@/components/ReviewAndRating/Gallery/GalleryList.vue"
  import ReviewList from "@/components/ReviewAndRating/ReviewList/ReviewList.vue"
  import MyReviewList from "@/components/ReviewAndRating/ReviewList/MyReviewList.vue"

  export default {
    name: "LayoutOneDesktop",
    components: {
      RatingSummary,
      RatingCta,
      MyReviewList,
      ReviewList,
      GalleryList,
    },
  }
</script>
